import { StatusCode } from '@swf/core/enums/statusCode';
import type { EffectParams } from '@swf/core/store';

import {
  TXTWCL_You_have_N0_interrupted_gameX__ELL,
  TXTWCL_You_have_N0_interrupted_gamesX_ELL
} from './fetchPlayerState.messages.json';

const fetchPlayerState = async (payload: undefined, { dispatch, request }: EffectParams) => {
  const statusCode = StatusCode.INTERRUPTED_GAME_ERROR;
  const { body } = await request({ service: `casino.player.state` });

  if (!body || !body[0]) {
    return;
  }

  const [{ liveT, intGms, xtk }] = body;
  const count = liveT.length + intGms.length;

  if (count > 0) {
    const message = {
      ...(count > 1
        ? TXTWCL_You_have_N0_interrupted_gamesX_ELL
        : TXTWCL_You_have_N0_interrupted_gameX__ELL),
      values: { 0: count }
    };
    const data = { liveT, intGms, xtk };

    dispatch.modal.enqueue({
      path: '/casino/error',
      locationState: { ...body, statusCode, data, message }
    });
  }
};

export default fetchPlayerState;
